import React from 'react';
import { Button, Dialog, IconButton, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface EnableKeywordAssistDialogProps {
  open: boolean;
  onClose: () => void;
  onEnable: () => void;
  isLoading?: boolean;
}

export const EnableKeywordAssistDialog: React.FC<EnableKeywordAssistDialogProps> = ({
  open,
  onClose,
  onEnable,
  isLoading
}) => {
  return (
    <Dialog open={open} onClose={() => !isLoading && onClose()} disableScrollLock>
      <div className="p-6 min-w-[600px] max-w-[600px] relative">
        <p className="text-primary font-semibold text-xl mb-3">
          Confirm Agent Activation
        </p>

        <p className="font-medium text-[15px] text-[#475467] mb-9">
          Enabling the agent will allow it to analyze your website keywords and provide optimization recommendations.
        </p>

        <div className="flex gap-2">
          <Button className='h-10 flex-1' variant="outlined" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button className='h-10 flex-1' variant="contained" onClick={onEnable} disabled={isLoading}>
            {isLoading ? (
              <CircularProgress size={20} sx={{ color: '#FFFFFF' }} />
            ) : (
              "Enable"
            )}
          </Button>
        </div>

        <div aria-label="dialog-close-btn" className="absolute top-0 right-0">
          <IconButton
            aria-label="close"
            className="hover:rounded-lg"
            sx={{
              position: 'absolute',
              top: 12,
              right: 12,
              zIndex: 2,
              height: '40px',
              padding: '8px',
              paddingRight: '8px'
            }}
            onClick={onClose}
            disabled={isLoading}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </div>
    </Dialog>
  );
};
